/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import { List } from 'immutable'
import AppDispatcher from '../../core/AppDispatcher'
import PlanEvent from '../../event/PlanEvent'
import { PlanState } from '../state/PlanState'

class PlansStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return List()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case PlanEvent.onSearch:
        if (!payload || !payload.plans) {
          return state
        }

        const plans = payload.plans.map(plan => new PlanState(plan))
        return List(plans)
      default:
        return state
    }
  }
}

export default new PlansStore()
